import { connect } from 'react-redux';
import ViewerLoader from './viewerLoader';

const mapStateToProps = state => ({
  loadingState: state.loadingState,
});

export default connect(mapStateToProps)(ViewerLoader);
